<style>
    .c-datepagination {
        margin: 0px;
        padding: 0px;
    }

    .c-datepagination li {
        list-style: none;
        float: left;
        border-top: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
        border-left: 1px solid #efefef;
        text-align: center;
        background-color: #fff;
        cursor: pointer;
    }

    .c-datepagination li.c-date {
        width: 35px;
        height: 60px;
        font-size: 13px;
        font-weight: 300;
        padding-top: 10px;
    }

    .c-datepagination li.c-arrow {
        width: 30px;
        height: 60px;
        font-size: 13px;
        font-weight: 300;
        padding-top: 20px;
    }

    .c-datepagination li.c-active {
        width: 198px;
        height: 60px;
        font-size: 14px;
        font-weight: 700;
        padding-top: 10px;
        color:#fff;
    }
</style>

<template>
    <ul class="c-datepagination" ref="datePagination">
        <li class="c-arrow" @click="prev()"><i class="fa fa-chevron-left"></i></li>
        <li v-for="date in dataDates"
            :style="getStyle(date.date)"
            @click="change(date.date)"
            :class="date.class"
            v-html="date.label"></li>
        <li class="c-arrow" @click="next()"><i class="fa fa-chevron-right"></i></li>
    </ul>
</template>
<script>
    const liSelectedWidth = 198
    const liWidth = 36
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    export default {
        name: 'DatePagination',
        components: {},
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        color: {
                            selectedBG: '#337ab7',
                            selectedFont: '#ffffff',
                            bg: '#ffffff',
                            font: '#232323'
                        }
                    }
                }
            },
            value: {
                type: String,
                default: Vue.moment().format('YYYY-MM-DD')
            },
            width: {
                type: Number,
                default: 0
            }
        },
        watch: {
            value(val) {
                this.change(val)
            },
            dataDate(val) {
                this.$emit('input', val)
            }
        },
        mounted() {
            this.calculateDates()
            this.change(this.value)
            window.addEventListener('resize', this.calculateDates)
            window.addEventListener('onload', this.calculateDates)
        },
        beforeDestroy: function () {
            window.removeEventListener('resize', this.calculateDates)
            window.removeEventListener('onload', this.calculateDates)
        },
        data: function () {
            return {
                dataDates: [],
                dataDate: '',
                dataWidth: 0
            }
        },
        methods: {
            handleResize () {
                if (this.$refs.datePagination.clientWidth === 0) {
                    this.dataWidth = this.width
                } else {
                    this.dataWidth = this.$refs.datePagination.clientWidth
                }
            },
            change(date) {
                if (date === '' || date === undefined) {
                    date = Vue.moment().format('YYYY-MM-DD')
                }
                this.dataDate = date
                this.calculateDates()
                this.$emit('input', this.dataDate)
                this.$emit('change', this.dataDate)
            },
            getStyle(date) {
                if (this.dataDate === date) {
                    return {
                        'background-color': this.options.color.selectedBG,
                        'color': this.options.color.selectedFont
                    }
                }
                return {
                    'background-color': this.options.color.bg,
                    'color': this.options.color.font
                }
            },
            prev() {
                this.change(Vue.moment(this.dataDate).add(-1, 'days').format('YYYY-MM-DD'))
            },
            next() {
                this.change(Vue.moment(this.dataDate).add(+1, 'days').format('YYYY-MM-DD'))
            },
            calculateDates () {
                this.dataDates = []
                let remainingWidth = this.dataWidth - liSelectedWidth - (liWidth * 2)
                let count = Math.round(remainingWidth / liWidth)
                let posSelected = Math.round(count / 2)
                for (let i = -posSelected; i <= (count - posSelected); i++) {
                    if (i === 0) {
                        this.dataDates.push({
                            class: 'c-active',
                            label: Vue.moment(this.dataDate).add(i, 'days').format('dddd') + '<br>' + Vue.moment(this.dataDate).add(i, 'days').format('DD MMMM YYYY'),
                            date: Vue.moment(this.dataDate).add(i, 'days').format('YYYY-MM-DD')
                        })
                    } else {
                        this.dataDates.push({
                            class: 'c-date',
                            label: Vue.moment(this.dataDate).add(i, 'days').format('dd.') + '<br>' + Vue.moment(this.dataDate).add(i, 'days').format('DD'),
                            date: Vue.moment(this.dataDate).add(i, 'days').format('YYYY-MM-DD')
                        })
                    }
                }
                this.handleResize()
            }
        }
    }
</script>

